export default {
    url: '/add',
    template: '<user-competence-competence-add/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/competence/competence/add/index.js